import axios from "axios";
import { PATH } from "../PATH";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../Auth/tokenKeys";
import { apiClient } from "./apiClient";

const services = {
  getFiles: async (page: string) => {
    return apiClient
      .get(page ? `/all-files/?page=${page}` : "/all-files/")
      .then((data: any) => data)
      .catch((err: any) => console.log(err));
  },
  deleteFile: async (file: string) => {
    return apiClient
      .get(`/delete-files/?file=${encodeURIComponent(file)}`)
      .then((data: any) => data)
      .catch((err: any) => console.log(err));
  },
  deletePublishedFile: async (file: string) => {
    return apiClient
      .get(`/delete-posts/?file=${encodeURIComponent(file)}`)
      .then((data: any) => data);
  },
  downloadFiles: async (file: string) => {
    return apiClient
      .get(`/download-files/?directory=templates&file=${encodeURIComponent(file)}`)
      .then((data: any) => data)
      .catch((err: any) => console.log(err));
  },
  doPost: async (body: FormData) => {
    return apiClient
      .post("/do-post/", body)
      .then((response: any) => response);
  },
  updatePost: async (body: any) => {
    return apiClient
      .post("/update-post/", body)
      .then((response: any) => response)
      .catch((err: any) => console.log(err));
  },
  getMe: async (body: { username: string; password: string }) => {
    const { data } = await axios.post<{ access: string; refresh: string }>(
      `${PATH.baseApi}/token/`,
      {
        username: body.username,
        password: body.password,
      }
    );
    if (!data.access || !data.refresh) {
      throw new Error("Resposta de autenticação inválida");
    }
    sessionStorage.setItem(ACCESS_TOKEN_KEY, data.access);
    sessionStorage.setItem(REFRESH_TOKEN_KEY, data.refresh);
    if (body.username) {
      sessionStorage.setItem("username", body.username);
    }
    return apiClient.get("/all-files/");
  },
  getAllPosts: async (page: string, auth: boolean, reverse_posts: boolean) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (reverse_posts) params.append("reverse_posts", "true");
    const qs = params.toString();
    const path = `/all-posts${qs ? `?${qs}` : ""}`;
    if (auth) {
      return apiClient
        .get(path)
        .then((data: any) => data);
    }
    return axios
      .get(`${PATH.baseApi}${path}`)
      .then((data: any) => data);
  },
  listPosts: async (page: string, auth: boolean) => {
    const path = page ? `/list-posts/?page=${page}` : "/list-posts/";
    if (auth) {
      return apiClient
        .get(path)
        .then((data: any) => data)
        .catch((err: any) => console.log(err));
    }
    return axios
      .get(`${PATH.baseApi}${path}`)
      .then((data: any) => data)
      .catch((err: any) => console.log(err));
  },
  favoritePosts: async () => {
    return axios
      .get(`${PATH.baseApi}/favorite-posts/`)
      .then((data: any) => data)
      .catch((err: any) => console.log(err));
  },
  patchFavoritePosts: async (file_name: string) => {
    return apiClient
      .patch("/favorite-posts/", { file_name })
      .then((response) => response.data)
      .catch((err) => {
        console.error(
          "Erro ao favoritar post:",
          (err as any).response?.data || (err as Error).message
        );
        throw err;
      });
  },
  getPublic: async (body: any, page?: string, reverse_posts?: boolean) => {
    const queryString = [
      body.date.from && `start_date=${body.date.from}`,
      body.date.to && `end_date=${body.date.to}`,
      body.post_type &&
        Array.isArray(body.post_type) &&
        body.post_type.length > 0 &&
        body.post_type.map((type: string) => `post_type=${type}`),
      Array.isArray(body.post_origin) &&
        body.post_origin.length > 0 &&
        body.post_origin.map((type: string) => `post_origin=${type}`),
      body.post_code &&
        body.post_code.length > 0 &&
        `post_code=${body.post_code}`,
      body.words &&
        Array.isArray(body.words) &&
        body.words.length > 0 &&
        body.words.map((word: string) => `words=${word}`),
      body.words_contain === true && `words_contain=${body.words_contain}`,
      page && `page=${page}`,
      reverse_posts && `reverse_posts=${reverse_posts}`,
    ]
      .filter(Boolean)
      .flat()
      .join("&");
    const url = `${PATH.baseApi}/search-files/${
      queryString.length > 0 ? "?" + queryString : ""
    }`;
    return axios
      .get(url)
      .then((data: any) => data);
  },
  resetPassword: async (body: any) => {
    return axios
      .post(`${PATH.baseApi}/password-reset/`, body)
      .then((data: any) => data)
      .catch((err: any) => console.log(err));
  },
  getFileContentBase64: (fileKey: string | undefined) => {
    return axios
      .get(`${PATH.baseApi}/render-html/?file_key=${fileKey}`)
      .then((response) => {
        if (response.data && response.data.file_content_base64) {
          return response.data.file_content_base64;
        }
        throw new Error(
          "A resposta da API não contém o conteúdo do arquivo em base64."
        );
      })
      .catch((error) => {
        console.error("Error fetching file content:", error);
        throw error;
      });
  },
  updatePostPosition: async (positions: number[]) => {
    return apiClient
      .put("/update-posts-position/", { positions })
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error updating post position:", error);
        throw error;
      });
  },
  updatePostDescription: async (
    file_name: string,
    description: string | undefined
  ) => {
    return apiClient
      .patch("/favorite-posts-description/", { file_name, description })
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error updating post description:", error);
        throw error;
      });
  },
  getAllHistoryLogs: async (filters: any, page?: string) => {
    let query = new URLSearchParams();

    if (filters.date?.from) query.append("start_date", filters.date.from);
    if (filters.date?.to) query.append("end_date", filters.date.to);
    if (filters?.action && filters.action.length > 0)
      query.append("action", filters.action.join(","));
    if (filters?.atoType && filters.atoType.length > 0)
      query.append("type", filters.atoType.join(","));
    if (filters?.user && filters.user.length > 0)
      query.append("author", filters.user.join(","));
    if (page) query.append("page", page);

    const url = `/history-logs/?${query.toString()}`;

    return apiClient
      .get(url)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching History logs:", error);
        throw error;
      });
  },
  getAllLogUsers: async () => {
    return apiClient
      .get("/all-log-users/")
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching all users author:", error);
        throw error;
      });
  },
};

export default services;

